import { Box, Button, Typography } from "@mui/material";
import CriSection from "../../components/CriSection";
import BookCover from "../../assets/images/flora_of_the_chigao_region_cover.png";
import Glossary from "../../assets/files/flora_glossary.pdf";

const IllustratedGlossary = () => {
  return (
    <CriSection alternate={true}>
      <Box
        sx={{
          display: "flex",
        }}
      >
        <Box
          sx={{
            marginRight: "36px",
            width: "400px",
          }}
        >
          <img
            src={BookCover}
            alt="Flora Book"
            style={{
              width: "100%",
              height: "300px",
              borderRadius: "12px",
              objectFit: "contain",
            }}
          />
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            flexBasis: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: "36px",
              fontWeight: 300,
              lineHeight: 1,
            }}
          >
            Illustrated Glossary
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 300,
              lineHeight: 1.2,
              marginTop: "12px",
            }}
          >
            Conservation Research Institute is pleased to offer an addition to
            the Flora of the Chicago Region, A Floristic and Ecological
            Synthesis - an illustrated glossary.
          </Typography>

          <Button
            variant="contained"
            component="a"
            href={Glossary}
            download
            sx={{
              marginTop: "24px",
              padding: "8px 36px",
            }}
          >
            Download
          </Button>
        </Box>
      </Box>
    </CriSection>
  );
};

export default IllustratedGlossary;
